import request from '../utils/request.js'

export default {
  // 获取退款列表
  getList (params) {
    return request.post(`refund/lists`, params).then(res => res.data)
  },
  
  // 申请退款
  apply (params) {
    return request.post(`refund/apply`, params).then(res => res.data)
  },
  
  // 审核退款
  audit (params) {
    return request.post(`refund/audit`, params).then(res => res.data)
  },
  
  // 删除退款申请
  delete (params) {
    return request.post(`refund/delete`, params).then(res => res.data)
  }
}



// WEBPACK FOOTER //
// ./src/api/refund.js